import React, { Component } from "react";
import { Row, Col, Select, Input, Tooltip, message } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import {
  Form,
  FormItem,
  ModalItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  SelectItem,
  SwitchItem,
} from "../../../../Components/Items";
import AgregarFamilia from "../../Familias/AgregarFamilia/AgregarFamilia";
import AgregarUnidad from "../../Insumos/AgregarInsumo/AgregarUnidad/AgregarUnidad";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";

const { Option } = Select;

// Palabras clave de la Presentacion -> nombre de Unidad a buscar; es sugerencia, no regla
const PISTAS_UNIDAD = [
  { patrones: ["MILILITRO", " ML", "ML)"], buscar: ["MILILITRO", "ML"] },
  { patrones: ["LITRO", " LT", "LT)"], buscar: ["LITRO", "LT"] },
  { patrones: ["KILOGRAMO", "KILO", " KG", "KG)"], buscar: ["KILOGRAMO", "KILO", "KG"] },
  { patrones: ["GRAMO", " G)", " G "], buscar: ["GRAMO"] },
  { patrones: ["PIEZA", " PZA", "PZA)"], buscar: ["PIEZA", "PZA"] },
  { patrones: ["CAJA"], buscar: ["CAJA"] },
  { patrones: ["PAQUETE", "PAQ"], buscar: ["PAQUETE", "PAQ"] },
  { patrones: ["BOTELLA", "ENVASE", "FRASCO"], buscar: ["PIEZA", "ENVASE", "FRASCO", "BOTELLA"] },
  { patrones: ["LATA"], buscar: ["LATA", "PIEZA"] },
];

const normalizarTexto = (valor) =>
  String(valor ?? "")
    .normalize("NFD")
    .replace(new RegExp("[\\u0300-\\u036f]", "g"), "")
    .toUpperCase();

const sugerirUnidadId = (presentacion, unidades) => {
  const texto = normalizarTexto(presentacion);
  if (!texto) return undefined;
  for (const pista of PISTAS_UNIDAD) {
    if (pista.patrones.some((patron) => texto.includes(patron))) {
      const unidad = unidades.find((item) =>
        pista.buscar.some((buscado) => normalizarTexto(item.nombre).includes(buscado))
      );
      if (unidad) return unidad._id;
    }
  }
  return undefined;
};

class ModalAltaInsumoImss extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    guardando: false,
    buscarInfoCode: false,
    todasFamilia: [],
    objetoFamilia: [],
    objetoUnidades: [],
    objetoImpuestos: [],
    objetoCuentasContablesFinales: [],
    objetoCodigoSat: [],
    listasPrecios: [],
    calcularPreciosSobre: false,
    modalAgregarFamilia: false,
    modalAgregarUnidad: false,
    modalAgregarCuentaContable: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.consultarTodo();
      if (this.formRef.current) this.formRef.current.resetFields();
    }
  }

  consultarTodo = async () => {
    this.setState({ loading: true });
    try {
      const [resDatos, resCuentas, resClaveExtra] = await Promise.all([
        axios.post(
          "insumos/selectDatosParaInsumo",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        ),
        axios.post(
          "cuentascontables/selectCuentasContablesFinales",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        ),
        axios.post(
          "insumos/sugerirClaveExtra",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        ),
      ]);

      const unidades = resDatos.data.unidades || [];
      const configuracion = resDatos.data.configuracion || {};
      const listasPrecios = (configuracion.precios || []).map((value) => ({
        porcentaje: value.porcentaje,
        nombre: value.nombre,
        precioId: value._id,
      }));
      this.setState(
        {
          loading: false,
          todasFamilia: resDatos.data.familias || [],
          calcularPreciosSobre: !!configuracion.calcularPreciosSobre,
          listasPrecios,
          objetoFamilia: (resDatos.data.familias || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre}
            </Option>
          )),
          objetoUnidades: unidades.map((value) => (
            <Option value={value._id} key={value._id}>
              {value.unidadSat.c_ClaveUnidad +
                " - " +
                (value.descripcion ? value.nombre + " - " + value.descripcion : value.nombre)}
            </Option>
          )),
          objetoImpuestos: (resDatos.data.impuestos || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre}
            </Option>
          )),
          objetoCuentasContablesFinales: (resCuentas.data || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.descripcion}
            </Option>
          )),
        },
        () => {
          const sugerido = sugerirUnidadId(this.props.fila?.presentacion, unidades);
          if (sugerido && !this.formRef.current?.getFieldValue("unidadId")) {
            this.formRef.current.setFieldsValue({ unidadId: sugerido });
          }
          if (!this.props.fila?.clave && resClaveExtra.data.success === 2 && !this.formRef.current?.getFieldValue("clave")) {
            this.formRef.current.setFieldsValue({ clave: resClaveExtra.data.clave });
          }
          const preciosActuales = this.formRef.current?.getFieldValue("precios");
          if ((!preciosActuales || preciosActuales.length === 0) && listasPrecios.length > 0) {
            this.formRef.current.setFieldsValue({ precios: listasPrecios });
          }
        }
      );
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
      message.error("No se pudieron cargar los catalogos para dar de alta el insumo");
    }
  };

  onChangeCodigo = (value) => {
    this.setState({ buscarInfoCode: true });
    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, codigo: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({
          buscarInfoCode: false,
          objetoCodigoSat: (res.data || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.c_ClaveProdServ + " - " + value.descripcion}
            </Option>
          )),
        });
      });
  };

  calcularPrecio = (costo, porcentaje) => {
    const valor = this.state.calcularPreciosSobre
      ? (costo * (100 + Number(porcentaje))) / 100
      : costo / ((100 - Number(porcentaje)) / 100);
    return Number(valor.toFixed(2));
  };

  onChangeCosto = (valueCosto) => {
    if (!this.formRef.current || !valueCosto) return;
    const precios = this.formRef.current.getFieldValue("precios") || [];
    this.formRef.current.setFieldsValue({
      precios: precios.map((item) => ({ ...item, precio: this.calcularPrecio(valueCosto, item.porcentaje) })),
    });
  };

  onChangePorcentajeLista = (indice, porcentaje) => {
    const costo = this.formRef.current.getFieldValue("costo");
    if (!costo) return;
    const precios = this.formRef.current.getFieldValue("precios");
    precios[indice] = { ...precios[indice], porcentaje, precio: this.calcularPrecio(costo, porcentaje) };
    this.formRef.current.setFieldsValue({ precios });
  };

  onChangePrecioLista = (indice, precio) => {
    const costo = this.formRef.current.getFieldValue("costo");
    if (!costo) return;
    const precios = this.formRef.current.getFieldValue("precios");
    const porcentaje = this.state.calcularPreciosSobre
      ? ((precio - costo) / costo) * 100
      : ((precio - costo) / precio) * 100;
    precios[indice] = { ...precios[indice], precio, porcentaje: Number(porcentaje.toFixed(2)) };
    this.formRef.current.setFieldsValue({ precios });
  };

  abrirAgregarFamilia = () => this.setState({ modalAgregarFamilia: true });
  cerrarAgregarFamilia = () => {
    this.setState({ modalAgregarFamilia: false });
    this.consultarTodo();
  };

  abrirAgregarUnidad = () => this.setState({ modalAgregarUnidad: true });
  cerrarAgregarUnidad = () => {
    this.setState({ modalAgregarUnidad: false });
    this.consultarTodo();
  };

  abrirAgregarCuentaContable = () => this.setState({ modalAgregarCuentaContable: true });
  cerrarAgregarCuentaContable = () => {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  };

  onFinishFailed = () => message.error("Revisa que los datos sean correctos");

  onFinish = (values) => {
    const { fila, clienteId } = this.props;
    const { codigoSatId, familiaId, unidadId, costo, impuestos, precios, ...resto } = values;

    this.setState({ guardando: true });
    axios
      .post(
        "insumosCliente/agregarInsumoClienteConInsumoNuevo",
        {
          empresaId: this.props.empresaId,
          clienteId,
          insumo: {
            descripcion: resto.descripcion,
            descripcionLarga: resto.descripcionLarga,
            clave: resto.clave,
            unidadId,
            costo,
            familiaId,
            cuentaIngresoContadoId: resto.cuentaIngresoContadoId,
            cuentaIngresoCreditoId: resto.cuentaIngresoCreditoId,
            codigoSatId,
            inventariable: !!resto.inventariable,
            impuestos: (impuestos || []).filter((item) => item?.impuestoId),
            precios: (precios || []).filter((item) => item?.precioId),
          },
          clienteInsumo: {
            nombreAlternativo: resto.nombreAlternativo,
            clave: resto.claveCliente || fila?.clave,
            precio: resto.precioCliente,
          },
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success("Se dio de alta el insumo y se vinculo al cliente");
          this.props.onGuardado();
        } else {
          message.error(res.data.message || "No se pudo dar de alta el insumo");
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        message.error("No se pudo dar de alta el insumo");
      });
  };

  render() {
    const { visible, onCancel, fila } = this.props;
    const {
      loading,
      guardando,
      buscarInfoCode,
      objetoFamilia,
      todasFamilia,
      objetoUnidades,
      objetoImpuestos,
      objetoCuentasContablesFinales,
      objetoCodigoSat,
      listasPrecios,
    } = this.state;
    const precioClienteEsObligatorio = listasPrecios.length === 0;

    return (
      <>
        <ModalItem
          title="Dar de alta insumo nuevo"
          visible={visible}
          onCancel={onCancel}
          width={1040}
          spinning={loading || guardando}
        >
          <Form
            ref={this.formRef}
            name="altaInsumoImss"
            layout
            bottom={
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <ButtonItem rojo onClick={onCancel}>
                  Cancelar
                </ButtonItem>
                <ButtonItem azul htmlType="submit">
                  Dar de alta y vincular
                </ButtonItem>
              </div>
            }
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={16}>
              <Col span={12}>
                <FormItem
                  label="Descripcion"
                  name="descripcion"
                  required
                  margin
                  pattern
                  initialValue={fila?.nombre}
                >
                  <InputItem placeholder="Descripcion" />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Descripcion larga"
                  name="descripcionLarga"
                  required
                  margin
                  pattern
                  initialValue={fila?.nombre}
                >
                  <InputItem placeholder="Descripcion larga" />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem label="Unidad" margin labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", minWidth: 0 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <FormItem name="unidadId" required noStyle>
                        <SelectItem placeholder="Unidad" width="100%">
                          {objetoUnidades}
                        </SelectItem>
                      </FormItem>
                    </div>
                    <Tooltip title="Agregar unidad">
                      <ButtonItem
                        icon={<PlusOutlined />}
                        onClick={this.abrirAgregarUnidad}
                        style={{ flexShrink: 0 }}
                      />
                    </Tooltip>
                  </div>
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem label="Familia" margin labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", minWidth: 0 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <FormItem name="familiaId" required noStyle>
                        <SelectItem placeholder="Familia" width="100%">
                          {objetoFamilia}
                        </SelectItem>
                      </FormItem>
                    </div>
                    <Tooltip title="Agregar familia">
                      <ButtonItem
                        icon={<PlusOutlined />}
                        onClick={this.abrirAgregarFamilia}
                        style={{ flexShrink: 0 }}
                      />
                    </Tooltip>
                  </div>
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Costo" name="costo" required margin number>
                  <InputNumberItem dinero placeholder="Costo" onChange={this.onChangeCosto} />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem name="inventariable" label="Inventariable" margin valuePropName="checked" initialValue={true}>
                  <SwitchItem />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Clave del insumo" name="clave" margin pattern>
                  <InputItem placeholder="Clave interna (opcional)" />
                </FormItem>
              </Col>

              <Col span={24}>
                <FormItem
                  label="Precios de venta"
                  margin
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  tooltip="Se calculan solos a partir del Costo y el % configurado en cada lista; se pueden ajustar a mano. Sin esto el insumo queda sin precio en ninguna lista."
                >
                  <Form.List name="precios" initialValue={this.state.listasPrecios}>
                    {(fields) => (
                      <Row gutter={16}>
                        {fields.map(({ name }, indice) => (
                          <Col span={8} key={indice}>
                            <div style={{ marginBottom: 4, fontSize: 12, color: "#888" }}>
                              {this.state.listasPrecios[indice]?.nombre}
                            </div>
                            <Input.Group compact>
                              <FormItem name={[name, "porcentaje"]} required numberCero noStyle>
                                <InputNumberItem
                                  sinWidth
                                  porcentaje
                                  style={{ width: "40%" }}
                                  onChange={(valor) => this.onChangePorcentajeLista(indice, valor)}
                                />
                              </FormItem>
                              <FormItem name={[name, "precio"]} required number noStyle>
                                <InputNumberItem
                                  sinWidth
                                  dinero
                                  style={{ width: "60%" }}
                                  onChange={(valor) => this.onChangePrecioLista(indice, valor)}
                                />
                              </FormItem>
                            </Input.Group>
                          </Col>
                        ))}
                      </Row>
                    )}
                  </Form.List>
                </FormItem>
              </Col>

              <Col span={24}>
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.familiaId !== curr.familiaId}>
                  {({ getFieldValue }) => {
                    const familiaId = getFieldValue("familiaId");
                    const familia = todasFamilia.find((item) => item._id.toString() === familiaId?.toString());
                    if (!familiaId || (familia?.cuentaIngresoContadoId && familia?.cuentaIngresoCreditoId)) return null;
                    return (
                      <Row gutter={16}>
                        <Col span={12}>
                          <FormItem label="Cuenta Ingreso Contado" margin>
                            <div style={{ display: "flex", gap: 8, alignItems: "center", minWidth: 0 }}>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <FormItem name="cuentaIngresoContadoId" required noStyle>
                                  <SelectItem placeholder="Cuenta Ingreso Contado" width="100%">
                                    {objetoCuentasContablesFinales}
                                  </SelectItem>
                                </FormItem>
                              </div>
                              <Tooltip title="Agregar cuenta contable">
                                <ButtonItem
                                  icon={<PlusOutlined />}
                                  style={{ flexShrink: 0 }}
                                  onClick={this.abrirAgregarCuentaContable}
                                />
                              </Tooltip>
                            </div>
                          </FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem label="Cuenta Ingreso Credito" margin>
                            <div style={{ display: "flex", gap: 8, alignItems: "center", minWidth: 0 }}>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <FormItem name="cuentaIngresoCreditoId" required noStyle>
                                  <SelectItem placeholder="Cuenta Ingreso Credito" width="100%">
                                    {objetoCuentasContablesFinales}
                                  </SelectItem>
                                </FormItem>
                              </div>
                              <Tooltip title="Agregar cuenta contable">
                                <ButtonItem
                                  icon={<PlusOutlined />}
                                  style={{ flexShrink: 0 }}
                                  onClick={this.abrirAgregarCuentaContable}
                                />
                              </Tooltip>
                            </div>
                          </FormItem>
                        </Col>
                      </Row>
                    );
                  }}
                </FormItem>
              </Col>

              <Col span={24}>
                <FormItem
                  label="Codigo SAT"
                  margin
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  tooltip="Sin codigo SAT el pedido no se puede crear con este insumo"
                >
                  <div style={{ display: "flex", gap: 8, alignItems: "flex-end", minWidth: 0 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <FormItem name="codigoSatId" required noStyle>
                        <SelectItem
                          mostrarCarga
                          loading={buscarInfoCode}
                          placeholder="Codigo Sat"
                          onSearch={(value) => this.onChangeCodigo(value)}
                        >
                          <Option disabled>Escriba para buscar el codigo</Option>
                          {objetoCodigoSat}
                        </SelectItem>
                      </FormItem>
                    </div>
                    <ButtonItem
                      style={{ flexShrink: 0 }}
                      onClick={() => window.open("http://pys.sat.gob.mx/PyS/catPyS.aspx", "_blank")}
                    >
                      Conoce tu código SAT
                    </ButtonItem>
                  </div>
                </FormItem>
              </Col>

              <Col span={24}>
                <FormItem label="Impuestos" margin>
                  <Form.List name="impuestos">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ name }, arrayKey) => (
                          <Row key={arrayKey.toString()} gutter={8} style={{ marginBottom: 8 }}>
                            <Col span={22}>
                              <FormItem name={[name, "impuestoId"]} fieldKey={[arrayKey, "impuestoId"]} required margin noStyle>
                                <SelectItem width="100%" placeholder="Impuesto">
                                  {objetoImpuestos}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={2}>
                              <MinusCircleOutlined onClick={() => remove(name)} />
                            </Col>
                          </Row>
                        ))}
                        <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                          Agregar impuesto
                        </ButtonItem>
                      </>
                    )}
                  </Form.List>
                </FormItem>
              </Col>

            </Row>

            <div style={{ borderTop: "1px solid #f0f0f0", margin: "10px 0 15px" }}>
              <p style={{ margin: "10px 0" }}>
                <b>Datos para este cliente</b>
              </p>
            </div>
            <Row gutter={16}>
              <Col span={8}>
                <FormItem
                  label="Nombre para el cliente"
                  name="nombreAlternativo"
                  required
                  margin
                  pattern
                  initialValue={fila?.nombre}
                >
                  <InputItem placeholder="Nombre que vera el cliente" />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem
                  label="Clave del cliente"
                  name="claveCliente"
                  margin
                  pattern
                  initialValue={fila?.clave}
                >
                  <InputItem placeholder="Clave del cliente" />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem
                  label="Precio unitario"
                  name="precioCliente"
                  required={precioClienteEsObligatorio}
                  margin
                  number
                  tooltip={
                    precioClienteEsObligatorio
                      ? "La empresa no tiene listas de precios configuradas: este precio es obligatorio, es la unica forma de que el insumo tenga precio para este cliente"
                      : "Opcional: si se captura, sustituye a la lista de precios de abajo al vender/cotizar/pedir a este cliente. Si se deja vacio, se usa la lista de precios elegida en el pedido."
                  }
                >
                  <InputNumberItem dinero placeholder="Precio unitario" />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </ModalItem>

        <AgregarUnidad visible={this.state.modalAgregarUnidad} cerrarAgregarUnidad={this.cerrarAgregarUnidad} />
        <AgregarFamilia visible={this.state.modalAgregarFamilia} cerrarAgregarFamilia={this.cerrarAgregarFamilia} />
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalAltaInsumoImss);
